import API from '@/api';
import qs from 'qs';

class TeamVolunteering
{
  /**
   * Do api call to get all users
   *
   * @return {promise}
   */
  static async listUsers(params) {
    return await API.dispatch(
      'GET',
      'listUsers',
      {
        query: params
      }
    );
  }

  /**
   * Do api call to manage team data
   *
   * @return {promise}
   */
  static async manageTeam(params, teamId) {
    return await API.dispatch(
      'POST',
      teamId ? 'updateTeam' : 'createTeam',
      {
        ...(teamId) && { path: { teamId } },
        data: params
      },
      {
        'Content-Type': 'multipart/form-data'
      }
    );
  }

  /**
   * Do api call to get all teams
   *
   * @return {promise}
   */
  static async listTeams(params) {
    return await API.dispatch(
      'GET',
      `app/teams?${qs.stringify(params)}`
    );
  }

  /**
   * Do api call to get team setup
   *
   * @return {promise}
   */
  static async getSetup() {
    return await API.dispatch(
      'GET',
      'teamSetup'
    );
  }

  /**
   * Do api call to update team member role
   *
   * @return {promise}
   */
  static async updateMemberRole(params) {
    return await API.dispatch(
      'PATCH',
      'updateTeamMemberRole',
      params,
      {
        'Content-Type': 'application/json'
      }
    );
  }

  /**
   * Do api call to delete a team member
   *
   * @return {promise}
   */
  static async deleteMember(params) {
    return await API.dispatch(
      'DELETE',
      'deleteMember',
      params,
      {
        'Content-Type': 'application/json'
      }
    );
  }

  /**
   * Do api call to manage team data
   *
   * @return {promise}
   */
  static async addMember(params) {
    return await API.dispatch(
      'POST',
      'addMember',
      params,
      {
        'Content-Type': 'application/json'
      }
    );
  }

  /**
   * Do api call to list applications of the team
   *
   * @return {promise}
   */
  static async listTeamApplications(params) {
    return await API.dispatch(
      'GET',
      'listTeamApplications',
      params
    );
  }

  /**
   * Do api call to archive a team
   *
   * @return {promise}
   */
  static async archiveTeam(teamId) {
    return await API.dispatch(
      'PATCH',
      'archiveTeam',
      {
        path: { teamId }
      }
    );
  }

  /**
   * Do api call to message team
   *
   * @return {promise}
   */
  static async messageTeam(params) {
    return await API.dispatch(
      'POST',
      'messageTeam',
      {
        path: { teamId: params.get('team_id') },
        data: params
      },
      {
        'Content-Type': 'multipart/form-data'
      }
    );
  }

  /**
   * Do api call to join a user to team
   *
   * @return {promise}
   */
  static async joinTeam(teamId) {
    return await API.dispatch(
      'POST',
      'joinTeam',
      {
        path: { teamId }
      },
      {
        'Content-Type': 'multipart/form-data'
      }
    );
  }

  /**
   * Do api call to leave the team
   *
   * @return {promise}
   */
  static async leaveTeam(teamId) {
    return await API.dispatch(
      'DELETE',
      'leaveTeam',
      {
        path: { teamId }
      }
    );
  }

  /**
   * Do api call to leave the team
   *
   * @return {promise}
   */
  static async teamTimesheetRequests(teamId, query) {
    return await API.dispatch(
      'GET',
      'teamTimesheetRequests',
      {
        path: { teamId },
        query,
      }
    );
  }

  /**
   * Do api call to get daily attendance
   *
   * @return {promise}
   */
  static async listAttendance(teamId, query) {
    return await API.dispatch(
      'GET',
      'listAttendance',
      {
        path: { teamId },
        query,
      },
      {
        'Content-Type': 'text/html',
      }
    );
  }

  /**
   * Redirect to export list attendance endpoint
   */
  static exportListAttendance(teamId, query) {
    API.export(
      'exportListAttendance',
      {
        path: { teamId },
        query,
        filename: query.filename || 'attendance-report.xlsx'
      }
    );
  }

  /**
   * Do api call to get daily attendance
   *
   * @return {promise}
   */
  static async dailyAttendance(teamId, query) {
    return await API.dispatch(
      'GET',
      'dailyAttendance',
      {
        path: { teamId },
        query,
      },
      {
        'Content-Type': 'text/html',
      }
    );
  }

  /**
   * Redirect to daily attendance export endpoint
   */
  static async dailyAttendanceExport(teamId, query) {
    API.export(
      'dailyAttendanceExport',
      {
        path: { teamId },
        query,
        filename: query.filename || 'daily-attendance-report.xlsx'
      },
      {
        'Accept': 'application/vnd.ms-excel'
      }
    );
  }
}

export default TeamVolunteering;
